import formatToCurrency from '../../../../utils/formatToCurrency';
import { capitalizeFirstLetter } from '../../../../utils/capitalizeFirstLetter';

export const parseVendorProduct = product => {
  let primaryImage = null;
  let images = [];

  if (product.imageUrl) {
    primaryImage = { isPrimary: true, url: product.imageUrl };
  } else {
    images = product?.images ? product.images.map((item, index) => ({ isPrimary: index === 0, url: item })) : [];
    primaryImage = images.find(image => image.isPrimary);
  }

  return {
    id: product.id,
    name: product.name,
    msrp: formatToCurrency(product.msrp),
    image: primaryImage ? primaryImage.url : null,
    images,
    sku: null,
    mpn: product.mpn,
    qty: null,
    posRefNum: null,
    description: product.description,
    attributes: {
      item_code: product.mpn,
      name: product.name,
      ...product.attributes,
    },
  };
};

export const parseClientbookProduct = product => {
  return {
    id: product.id,
    name: product.name,
    price: formatToCurrency(product.price),
    image: product.image,
    images: product?.images || [],
    sku: product.sku,
    mpn: null,
    qty: product.qty,
    posRefNum: product.posRefNum,
    description: product.description,
    attributes: {
      brand: capitalizeFirstLetter(product.brand),
      cat_level_1: capitalizeFirstLetter(product.categoryLevel1),
      cat_level_2: capitalizeFirstLetter(product.categoryLevel2),
      cat_level_3: capitalizeFirstLetter(product.categoryLevel3),
      color: capitalizeFirstLetter(product.color),
      material: capitalizeFirstLetter(product.material),
      msrp: capitalizeFirstLetter(product.msrp),
      pattern: capitalizeFirstLetter(product.pattern),
      sku: capitalizeFirstLetter(product.sku),
      stone_clarity: capitalizeFirstLetter(product.stoneClarity),
      stone_color: capitalizeFirstLetter(product.stoneColor),
      stone_shape: capitalizeFirstLetter(product.stoneShape),
      stone_size: capitalizeFirstLetter(product.stoneSize),
      stone_type: capitalizeFirstLetter(product.stoneType),
      total_diamond_weight: capitalizeFirstLetter(product.totalDiaWt),
      unit_cost: formatToCurrency(product.price),
      upc: capitalizeFirstLetter(product.upc),
      vendor_style: capitalizeFirstLetter(product.vendorStyle),
      in_stock_at:
        product?.inStockAt === null ? null : product?.inStockAt?.length > 0 ? product?.inStockAt.join(', ') : 'None',
    },
  };
};
